import { createReducer, on } from '@ngrx/store';
import { OrganizationUsersState } from '../../models/organizations/users.model';
import * as OrganizationsActions from '../../actions/organizations/users.actions';
import * as AuthActions from '../../actions/auth.actions';

export const initialOrganizationUsersState: OrganizationUsersState = {
  usersByOrgId: {}
};

export const organizationUsersReducer = createReducer(
  initialOrganizationUsersState,

  on(OrganizationsActions.loadOrganizationUsersSuccess, (state, { organizationId, users }) => ({
    ...state,
    usersByOrgId: {
      ...state.usersByOrgId,
      [organizationId]: users
    }
  })),

  on(OrganizationsActions.updateOrganizationUserRoleSuccess, (state, { organizationId, user, role }) => {
    const prev = state.usersByOrgId?.[organizationId] || [];
    return {
      ...state,
      usersByOrgId: {
        ...state.usersByOrgId,
        [organizationId]: prev.map(u => u.user.id === user.id ? { user, role } : u)
      }
    };
  }),

  on(OrganizationsActions.removeOrganizationUserSuccess, (state, { organizationId, userId }) => {
    const prev = state.usersByOrgId?.[organizationId] || [];
    return {
      ...state,
      usersByOrgId: {
        ...state.usersByOrgId,
        [organizationId]: prev.filter(u => u.user.id !== userId)
      }
    };
  }),

  // Reset organization users state on logout or clearUserData
  on(AuthActions.logout, AuthActions.clearUserData, () => initialOrganizationUsersState)
);